
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import NavHeader from "@/components/semantics/NavHeader.vue";
import Footer from "@/components/semantics/Footer.vue";
import Declare from "../detail/Declare.vue";
// import Footer from '@components/footer/Footer.vue';
@Component({
  name: "StationPcm",
  components: {
    NavHeader,
    Footer,
  },
})
export default class StationPcm extends Vue {
  isOverflow: any = true;
  dialogVisible: boolean = false;
  policyAdviceInput: string = '';
  mounted() {
    const pcm = document.getElementById("pcm");
    // (pcm as any).
    (pcm as any).addEventListener("scroll", () => {
      this.isOverflow = false;
    });
  }
  @Watch("$route", { immediate: true })
  handleChange() {
    this.isOverflow = true;
  }
  pushPopoverPolicyAdvice(){

  }
}
